import { Component, OnInit } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  public sortColumn:any = 'userName';
  public sortType:boolean = false ;
  public searchList: any = ['userName', 'email'];
  constructor(public service: AmbitService,
    public router: Router) {
      if(this.service.adminUser.userAccess.passengers =='None') {
        this.router.navigate(['/home']);
      }
   }

  ngOnInit() {
  }

  toggleSortValue(val) {
    if(this.sortColumn==val){
      this.sortType = !this.sortType ;
    } else {
      this.sortColumn = val;
    }
  }

}